import {call, put, takeLatest} from 'redux-saga/effects'
import {addNotificationAC} from "../system/systemActionCreators";
import {
    dStatisticsSetDailyDataSagaAC,
    dStatisticsSetDailyLoaderAC, dStatisticsSetDailyStatisticDataAC,
    dStatisticsSetDataSagaAC, dStatisticsSetEmployeeStatisticDataAC,
    dStatisticsSetHoursStatisticDataAC,
    dStatisticsSetLoaderAC,
    dStatisticsSetMainRefundAmountDailyStatisticDataAC, dStatisticsSetMainRefundAmountMonthlyStatisticDataAC,
    dStatisticsSetMainRefundAmountWeeklyStatisticDataAC,
    dStatisticsSetMainRefundCountDailyStatisticDataAC,
    dStatisticsSetMainRefundCountMonthlyStatisticDataAC,
    dStatisticsSetMainRefundCountWeeklyStatisticDataAC,
    dStatisticsSetMainSaleAmountDailyStatisticDataAC,
    dStatisticsSetMainSaleAmountMonthlyStatisticDataAC,
    dStatisticsSetMainSaleAmountWeeklyStatisticDataAC,
    dStatisticsSetMainSaleAverageDailyStatisticDataAC,
    dStatisticsSetMainSaleAverageMonthlyStatisticDataAC,
    dStatisticsSetMainSaleAverageWeeklyStatisticDataAC,
    dStatisticsSetMainSaleCountDailyStatisticDataAC,
    dStatisticsSetMainSaleCountMonthlyStatisticDataAC,
    dStatisticsSetMainSaleCountWeeklyStatisticDataAC,
    dStatisticsSetPaymentMethodAmountStatisticDataAC,
    dStatisticsSetPaymentMethodCountStatisticDataAC, dStatisticsSetProductStatisticDataAC,
    dStatisticsSetRefundStatisticDataAC,
    dStatisticsSetSaleStatisticDataAC,
    dStatisticsSetSaleTypeAmountStatisticDataAC, dStatisticsSetSaleTypeCountStatisticDataAC,
    dStatisticsSetWeekDayStatisticDataAC
} from "./dStatisticsActionCreators";
import {
    getStatisticPayments,
    getStatisticRefunds,
    typeStatisticsRequestFilters
} from "./dStatisticsAPI";
import {typeDailyStatistic} from "./dStatisticsReducer";



// ---------------------------------------------------------------------------------------------------------------------
// Get sales list
export function* dStatisticsSetDailyDataWorker (actionObject:{
    type: string,
    payload: {statisticFilter: typeStatisticsRequestFilters }
}) {

    yield put(dStatisticsSetDailyLoaderAC(true))

    let responsePayments = yield call(getStatisticPayments, actionObject.payload.statisticFilter)
    let responseRefunds = yield call(getStatisticRefunds, actionObject.payload.statisticFilter)

    /*
    if (responsePayments.status === 200) {
        yield put(dStatisticsSetSaleStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetMainSaleAmountDailyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAmountWeeklyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAmountMonthlyStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetMainSaleCountDailyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleCountWeeklyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleCountMonthlyStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetMainSaleAverageDailyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAverageWeeklyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAverageMonthlyStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetHoursStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetWeekDayStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetPaymentMethodAmountStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetPaymentMethodCountStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetSaleTypeAmountStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetEmployeeStatisticDataAC(responsePayments.data))
    } else {
        const id = new Date()
        yield put(addNotificationAC({
            id: id.getTime().toString(),
            message: 'ERROR_STATISTIC',
        }))
    }

    if (responseRefunds.status === 200) {
        yield put(dStatisticsSetRefundStatisticDataAC(responseRefunds.data))

        yield put(dStatisticsSetMainRefundCountDailyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundCountWeeklyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundCountMonthlyStatisticDataAC(responseRefunds.data))

        yield put(dStatisticsSetMainRefundAmountDailyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundAmountWeeklyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundAmountMonthlyStatisticDataAC(responseRefunds.data))
    } else {
        const id = new Date()
        yield put(addNotificationAC({
            id: id.getTime().toString(),
            message: 'ERROR_STATISTIC',
        }))
    }
    */


    if (responsePayments.status === 200 && responseRefunds.status === 200) {
        const dataObj: typeDailyStatistic = {
            saleTotalAmount: responsePayments.data.totalSummary.totalAmount ? Number(responsePayments.data.totalSummary.totalAmount) : 0,
            saleCount: responsePayments.data.totalSummary.count ? Number(responsePayments.data.totalSummary.count) : 0,
            saleAverageAmount: responsePayments.data.totalSummary.averageAmount ? Number(responsePayments.data.totalSummary.averageAmount) : 0,
            refundTotalAmount: responseRefunds.data.totalSummary.totalAmount ? Number(responseRefunds.data.totalSummary.totalAmount) : 0,
            refundCount: responseRefunds.data.totalSummary.count ? Number(responseRefunds.data.totalSummary.count) : 0,
            refundAverageAmount: responseRefunds.data.totalSummary.averageAmount ? Number(responseRefunds.data.totalSummary.averageAmount) : 0,
        }

        yield put(dStatisticsSetDailyStatisticDataAC(dataObj))

    } else {
        const id = new Date()
        yield put(addNotificationAC({
            id: id.getTime().toString(),
            message: 'ERROR_STATISTIC',
        }))
    }




    yield put(dStatisticsSetDailyLoaderAC(false))

}

export function* dStatisticsSetDailyDataWatcher () {
    yield takeLatest(dStatisticsSetDailyDataSagaAC.type, dStatisticsSetDailyDataWorker)
}



// ---------------------------------------------------------------------------------------------------------------------
// Get sales list
export function* dStatisticsSetDataWorker (actionObject:{
    type: string,
    payload: {statisticFilter: typeStatisticsRequestFilters }
}) {

    yield put(dStatisticsSetLoaderAC(true))

    let responsePayments = yield call(getStatisticPayments, actionObject.payload.statisticFilter)
    let responseRefunds = yield call(getStatisticRefunds, actionObject.payload.statisticFilter)

    //console.log(responsePayments)

    if (responsePayments.status === 200) {
        yield put(dStatisticsSetSaleStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetMainSaleAmountDailyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAmountWeeklyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAmountMonthlyStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetMainSaleCountDailyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleCountWeeklyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleCountMonthlyStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetMainSaleAverageDailyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAverageWeeklyStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetMainSaleAverageMonthlyStatisticDataAC(responsePayments.data))

        yield put(dStatisticsSetHoursStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetWeekDayStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetPaymentMethodAmountStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetPaymentMethodCountStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetSaleTypeAmountStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetSaleTypeCountStatisticDataAC(responsePayments.data))
        yield put(dStatisticsSetEmployeeStatisticDataAC(responsePayments.data))
    } else {
        const id = new Date()
        yield put(addNotificationAC({
            id: id.getTime().toString(),
            message: 'ERROR_STATISTIC',
        }))
    }

    if (responseRefunds.status === 200) {
        yield put(dStatisticsSetRefundStatisticDataAC(responseRefunds.data))

        yield put(dStatisticsSetMainRefundCountDailyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundCountWeeklyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundCountMonthlyStatisticDataAC(responseRefunds.data))

        yield put(dStatisticsSetMainRefundAmountDailyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundAmountWeeklyStatisticDataAC(responseRefunds.data))
        yield put(dStatisticsSetMainRefundAmountMonthlyStatisticDataAC(responseRefunds.data))
    } else {
        const id = new Date()
        yield put(addNotificationAC({
            id: id.getTime().toString(),
            message: 'ERROR_STATISTIC',
        }))
    }

    if (responseRefunds.status === 200 && responseRefunds.status === 200) {
        yield put(dStatisticsSetProductStatisticDataAC(responsePayments.data, responseRefunds.data))
    } else {
        const id = new Date()
        yield put(addNotificationAC({
            id: id.getTime().toString(),
            message: 'ERROR_STATISTIC',
        }))
    }


    yield put(dStatisticsSetLoaderAC(false))

}

export function* dStatisticsSetDataWatcher () {
    yield takeLatest(dStatisticsSetDataSagaAC.type, dStatisticsSetDataWorker)
}
